import type { Contact } from '~/types/person/contacts';

// Holds the contact selected for the outgoing-call flow (OutgoingCallModal /
// CallConnectedModal). Everything else contact-related lives in useContactsStore.
export const useContactsTempStore = defineStore('contacts-temp', () => {
    const selectedContact = ref<Contact | null>(null);

    return {
        selectedContact,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useContactsTempStore, import.meta.hot));
}
